import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
* {
    box-sizing: border-box;
    font-family: 'Opens Sans', sans-serif;
    
}
html, body{
    margin: 0;
    color: rgba(0,0,0,0.87);
    padding: 0;
    font-family: times-light, "Times New Roman", sans-serif;
    outline: 0;
    background-color: #fff;
    width: 100%;
   
    
}

.mobile{
    
    width:80%;
    height:auto;
    display:flex;
    flex-direction:column;
    text-align:center;
    
}

.custom-radio  {
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items:center;
  text-align:justify;
  
}
.custom-radio .ant-radio-wrapper {
  font-size: 18px;
}
.formItems{
    width:100%;
    
}

.formItems label {
  font-weight: bold;
}

.containerEmpreendimento {
    display: flex; 
    justify-content: center;
    flex-direction:column;
    align-items:center;
   
}
.selectEmpreendimento{
    
    width:100%
}
.checkBoxEmpreendimento{
     
    margin-top:20px
}


@media (max-width: 430px) {
   .mobile {
    width: 100% !important;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
  }

  .mobile .ant-card-head {
    width: 100%;
  }

  .mobile .ant-card-head-title {
    width: 100%;
    display: flex;
    justify-content: center;
    
    padding: 8px; /* ajuste o padding conforme necessário */
  }
  .formItems {
    width: 250px !important; 
  }
  .buttonForm {
    margin-top: 8%;
    margin-left: -65%;
  }
  .terceiroPassoStyle {
    display: flex; 
    justify-content: center;
    flex-direction: column;
    margin-top: 2%;
    width: 250px;
  }
  .custom-radio .ant-radio-wrapper {
    font-size: 16px;
  }
}

@media (min-width: 431px) and (max-width: 820px) {
  .mobile {
    width: 520px !important;
  }
}

@media (min-width: 821px) and (max-width: 1025px) {
  .mobile {
    /* Estilos para este intervalo de largura */
  }
}
@media (min-width: 1280px) {
  .mobile {
    width:100%
  }
}
    :root {
      --primary: #003644;
      --secondary: #003644;
      --background: #f8f9fa;
      --text: #222;
    }
    body {
      margin: 0;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      background-color: var(--background);
      color: var(--text);
    }
    header {
      background-color: var(--primary);
      color: white;
      padding: 1.5rem;
      text-align: center;
      position: relative;
    }
    header h1 {
      margin: 0;
      font-size: 2rem;
    }
    .proprietario-link {
      position: absolute;
      top: 1rem;
      right: 1rem;
      font-size: 1.5rem;
      color: white;
      text-decoration: none;
      transition: color 0.3s;
    }
    .proprietario-link:hover {
      color: #ccc;
    }
    .scroll-hint {
      text-align: center;
      margin-top: -1rem;
      animation: bounce 1.5s infinite;
      font-size: 1.5rem;
      color: #003644;
      display: none;
    }
    .descubra-texto {
      text-align: center;
      color: #555;
      font-size: 1rem;
      margin-top: 0.5rem;
      font-style: italic;
      display: none;
    }
    @media (max-width: 768px) {
      .scroll-hint {
        display: flex;
        justify-content: center;
      }
      .descubra-texto {
        display: block;
      }
    }
    @keyframes bounce {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(8px); }
    }
    main {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1.5rem;
      padding: 2rem;
      max-width: 1200px;
      margin: auto;
    }
    .card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      padding: 2rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .card:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 16px rgba(0,0,0,0.15);
    }
    .card i {
      transition: transform 0.3s ease;
    }
    .card:hover i {
      transform: scale(1.2);
    }
    .card h2 {
      margin-bottom: 1rem;
    }
    .card a {
      margin-top: 1.5rem;
      padding: 0.75rem 1.5rem;
      background-color: var(--secondary);
      color: white;
      text-decoration: none;
      border-radius: 8px;
      transition: background-color 0.2s;
      align-self: center;
    }
    .card a:hover {
      background-color: #002a33;
    }
    footer {
      background-color: #002a33;
      padding: 2rem;
      text-align: center;
      color: white;
    }
    footer h3 {
      margin-bottom: 0.5rem;
    }
    footer p {
      max-width: 800px;
      margin: auto;
      color: #ddd;
    }
    .footer-links {
      margin-top: 1.5rem;
      display: flex;
      justify-content: center;
      gap: 2rem;
      flex-wrap: wrap;
    }
    .footer-links a {
      color: #aad;
      text-decoration: none;
      transition: color 0.3s;
    }
    .footer-links a:hover {
      color: #fff;
    }
    .footer-bottom {
      text-align: center;
      font-size: 0.9rem;
      padding: 1rem;
      background-color: #001f26;
      color: #aaa;
    }
      .card-grid {
  display: grid;
  grid-template-columns: 1fr; /* padrão mobile: 1 card por linha */
  gap: 20px;
  padding: 20px;
  padding-bottom: 80px;
}

@media (min-width: 768px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr); /* desktop: 3 cards por linha */
  }
}

.card {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  transition: transform 0.2s ease;
}

.card:hover {
  transform: scale(1.02);
}
  .card i {
  transition: transform 0.3s ease-in-out;
}

.card:hover i {
  transform: scale(1.15);
}


`;
